import { render } from "./AtualizacaoPreco.vue?vue&type=template&id=81539534&scoped=true&ts=true"
import script from "./AtualizacaoPreco.vue?vue&type=script&lang=ts"
export * from "./AtualizacaoPreco.vue?vue&type=script&lang=ts"

import "./AtualizacaoPreco.vue?vue&type=style&index=0&id=81539534&scoped=true&lang=css"

import exportComponent from "/home/arthur/ProjetoVue/revista/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81539534"]])

export default __exports__